module.exports = __webpack_public_path__ + "img/Bodice-Front-B1-Db-Ee.b5e21320.png";